module.exports = __webpack_public_path__ + "media/images/dummy_item14-41ab27779bf39d18d6473677359a86a8.jpg";